import type { LegalEntity, NaturalPerson } from 'generated/gql';
import {
  PartyType,
  useCreateLegalEntityMutation,
  useCreateNaturalPersonMutation,
} from 'generated/gql';
import { t } from '@lingui/macro';
import type { PartyCreateFormValues } from 'forms/mutation/PartyCreateForm';
import { useCallback } from 'react';

export const useCreateNaturalPerson = (registerId: string) => {
  const [createNaturalPerson] = useCreateNaturalPersonMutation();
  return useCallback(
    async (party: PartyCreateFormValues & { naturalPerson: NaturalPerson }) => {
      const response = await createNaturalPerson({
        variables: {
          registerId,
          naturalPerson: party.naturalPerson,
        },
      });
      if (response.errors || !response.data)
        return {
          errors: response.errors,
          message: t`De natuurlijke persoon kon niet worden aangemaakt. Probeer het alstublieft opnieuw.`,
        };

      const { createNaturalPerson: naturalPerson } = response.data;
      return {
        id: naturalPerson.id,
        naturalPerson,
        type: PartyType.NaturalPerson,
      };
    },
    [createNaturalPerson, registerId],
  );
};

export const useCreateLegalEntity = (registerId: string) => {
  const [createLegalEntity] = useCreateLegalEntityMutation();
  return useCallback(
    async (party: PartyCreateFormValues & { legalEntity: LegalEntity }) => {
      const response = await createLegalEntity({
        variables: {
          registerId,
          legalEntity: party.legalEntity,
        },
      });
      if (response.errors || !response.data)
        return {
          errors: response.errors,
          message: t`De rechtspersoon kon niet worden aangemaakt. Probeer het alstublieft opnieuw.`,
        };

      const { createLegalEntity: legalEntity } = response.data;
      return {
        id: legalEntity.id,
        legalEntity,
        type: PartyType.LegalEntity,
      };
    },
    [createLegalEntity, registerId],
  );
};
